module.exports = __webpack_public_path__ + "img/BG000694749.0aa4e8f3.png";